import { OtpChannel, OtpRequestChannelType } from '../modules/account/_types/otp.types';

export interface ChannelConfig {
  value: OtpChannel;
  label: string;
  displayName: string;
}

export interface ValidationChannelConfig {
  channels: ChannelConfig[];
  defaultChannel?: OtpChannel;
}

export const otpRequestChannelTypeMapper = {
  /**
   * Mapeia o ValidationChannelType para os canais disponíveis
   */
  getAvailableChannels: (
    validationType: OtpRequestChannelType,
    userData: { phoneNumber?: string; email?: string }
  ): ValidationChannelConfig => {
    const {phoneNumber, email} = userData;
    
    switch (validationType) {
      case 'All':
        return {
          channels: [
            ...(email ? [{
              value: 'email' as OtpChannel,
              label: `E-mail para ${email}`,
              displayName: 'E-mail'
            }] : []),
            ...(phoneNumber ? [{
              value: 'sms' as OtpChannel,
              label: `SMS para ${phoneNumber}`,
              displayName: 'SMS'
            }] : []),
            ...(phoneNumber ? [{
              value: 'whatsApp' as OtpChannel,
              label: `WhatsApp para ${phoneNumber}`,
              displayName: 'WhatsApp'
            }] : [])
          ],
          defaultChannel: 'whatsApp'
        };
      
      case 'OnlyEmail':
        return {
          channels: email ? [{
            value: 'email' as OtpChannel,
            label: `E-mail para ${email}`,
            displayName: 'E-mail'
          }] : [],
          defaultChannel: 'email'
        };
      
      case 'OnlySms':
        return {
          channels: phoneNumber ? [{
            value: 'sms' as OtpChannel,
            label: `SMS para ${phoneNumber}`,
            displayName: 'SMS'
          }] : [],
          defaultChannel: 'sms'
        };
      
      case 'OnlyWhatsApp':
        return {
          channels: phoneNumber ? [{
            value: 'whatsApp' as OtpChannel,
            label: `WhatsApp para ${phoneNumber}`,
            displayName: 'WhatsApp'
          }] : [],
          defaultChannel: 'whatsApp'
        };
      
      case 'EmailOrSms':
        return {
          channels: [
            ...(email ? [{
              value: 'email' as OtpChannel,
              label: `E-mail para ${email}`,
              displayName: 'E-mail'
            }] : []),
            ...(phoneNumber ? [{
              value: 'sms' as OtpChannel,
              label: `SMS para ${phoneNumber}`,
              displayName: 'SMS'
            }] : [])
          ],
          defaultChannel: email ? 'email' : 'sms'
        };
      
      case 'EmailAndWhatsApp':
        return {
          channels: [
            ...(email ? [{
              value: 'email' as OtpChannel,
              label: `E-mail para ${email}`,
              displayName: 'E-mail'
            }] : []),
            ...(phoneNumber ? [{
              value: 'whatsApp' as OtpChannel,
              label: `WhatsApp para ${phoneNumber}`,
              displayName: 'WhatsApp'
            }] : [])
          ],
          defaultChannel: email ? 'email' : 'whatsApp'
        };
      
      case 'SmsOrWhatsApp':
        return {
          channels: [
            ...(phoneNumber ? [{
              value: 'sms' as OtpChannel,
              label: `SMS para ${phoneNumber}`,
              displayName: 'SMS'
            }] : []),
            ...(phoneNumber ? [{
              value: 'whatsApp' as OtpChannel,
              label: `WhatsApp para ${phoneNumber}`,
              displayName: 'WhatsApp'
            }] : [])
          ],
          defaultChannel: 'sms'
        };
      
      default:
        return {
          channels: [],
          defaultChannel: undefined
        };
    }
  },
  
  /**
   * Determina a pergunta baseada no número de canais disponíveis
   */
  getSecurityCodeQuestion: (channelsCount: number): string => {
    if (channelsCount === 0) {
      return 'Nenhum canal de validação disponível.';
    }
    
    if (channelsCount === 1) {
      return 'Você quer receber seu código de acesso aqui?';
    }
    
    return 'Por onde quer receber seu código de acesso?';
  }
};
